export class EventService {
    handlers: { [message: string]: Array<Function> } = {};

    static $inject = ["$q", "$log"];
    constructor(private $q: ng.IQService, private $log: ng.ILogService) { }

    /*
     * Attach handler to a message hook
     */
    on(message: string, handler: Function) {
        this.handlers[message] = this.handlers[message] || new Array<Function>();
        this.handlers[message].push(handler);
    }
    /*
     * Call a message with optional data
     */
    call(message: string, data?: any) {
        var promises = new Array<ng.IPromise<void>>();
        _.forEach(this.handlers[message] || [],
            (handler: (data?: any) => void) => {
                promises.push(this.$q.when(handler(data)));
            });
        return this.$q.all(promises);
    }
}